import React from 'react';
import { Dialog, Button, Text, useToasts } from '@applyboard/crystal-ui';
import { useDeleteConversionTable } from '../../data/useDeleteConversionTable';
import { useErrorHandler } from '~/hooks/useErrorHandler';
import type { ConversionTableResource } from '@ab/ams-school-api/types/private/v1';

export function DeleteConversionTableDialog(props: { conversionTable: ConversionTableResource; onClose: () => void }) {
  const { deleteConversionTable, isDeleting } = useDeleteConversionTable();
  const { apiError } = useErrorHandler();
  const toasts = useToasts();
  const { conversionTable } = props;

  const handleDelete = React.useCallback(() => {
    deleteConversionTable({ conversionTable })
      .then(() => {
        toasts.positive('Successfully deleted grade conversion');
        props.onClose();
      })
      .catch(() => {
        apiError();
      });
  }, [deleteConversionTable, conversionTable, toasts, apiError, props]);

  return (
    <Dialog
      open={true}
      onOpenChange={(open) => {
        if (!open && !isDeleting) props.onClose();
      }}
    >
      <Dialog.Heading>Delete grade conversion</Dialog.Heading>
      <Dialog.Content>
        <Text>
          Are you sure you want to delete the grade conversion &ldquo;{conversionTable.attributes.name}&rdquo;? This
          action cannot be undone.
        </Text>
      </Dialog.Content>
      <Dialog.Actions>
        <Dialog.CloseButton width="fill" disabled={isDeleting}>
          Cancel
        </Dialog.CloseButton>
        <Button intent="negative" width="fill" onClick={handleDelete} loading={isDeleting}>
          Delete Conversion
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
}
